import{jsxs as o,jsx as r}from"react/jsx-runtime";import{styled as t}from"styled-components";import{FunctionBlock as e}from"./FunctionBlock.mjs";import{useAuthFunctionItem as i}from"../hooks/useAuthFunctionItem.mjs";import{useTab as n}from"../context/TabContext.mjs";const m=t.div.attrs({className:"tab-panel"})`
  display: flex;
  background: url(images/tab_header.png) repeat-x;
  padding: 1em 1.4em;
  border: 1px solid #999999;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  box-shadow: 2px 2px 3px #888888;
`,d=t.div`
  flex: 1;
`;function a({value:t,columns:a}){var l,p,s;const{currentTab:c}=n(),u=i(a);return t===c&&o(m,{children:[r(d,{children:null===(l=u[0])||void 0===l?void 0:l.map(((o,t)=>r(e,{...o},t)))}),r(d,{children:null===(p=u[1])||void 0===p?void 0:p.map(((o,t)=>r(e,{...o},t)))}),r(d,{children:null===(s=u[2])||void 0===s?void 0:s.map(((o,t)=>r(e,{...o},t)))})]})}export{a as TabPanel};
